import React from 'react';
import { Heart } from 'lucide-react';

const FloatingHearts = () => {
  return (
    <div className="fixed inset-0 pointer-events-none">
      {[...Array(20)].map((_, i) => (
        <Heart
          key={i}
          className="absolute animate-float text-red-500"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            transform: `scale(${Math.random() + 0.5})`,
          }}
        />
      ))}
    </div>
  );
};

export default FloatingHearts;